import { useQuery } from '@tanstack/react-query'
import { UsersApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

/**
 * ユーザー一覧取得時のデフォルト上限数
 *
 * limit を指定しなかった場合、API 側のデフォルト値として 500 が設定される。
 * しかし、500 以上のユーザーが存在する場合はすべてのユーザーを取得できず、
 * 結果的に一部のデータしか取得できないことになる。
 *
 * 2,818 名登録の company で承認者選択 / ユーザーグループ編集ができない
 * お客様事象 (HPB-6684) が発生したため、余裕を持って 5,000 を上限とする。
 * 詳細な根拠は EditApprovalFlowDrawer の APPROVERS_FETCH_LIMIT 周辺コメントを参照。
 */
const DEFAULT_USERS_LIMIT = 5000

export const useQueryUsers = (limit: number = DEFAULT_USERS_LIMIT) => {
  return useQuery({
    queryKey: queryKeys.users(limit),
    queryFn: async () => {
      const response = await baseClient
        .getApi(UsersApi)
        .getUsers({ limit })
        .catch(handleHTTPError)
      return response.users
    },
  })
}
